import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {getStatusText, OrderStatusEnum} from "../../../store/state/order.state";

@Component({
    selector: 'status-label',
    templateUrl: './status-label.template.html',
    styleUrls: ['./status-label.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatusLabelComponent {

	@Input() status: OrderStatusEnum;

	getStatusText(): string {
		return getStatusText(this.status);
	}

	statusClass(): string {
		return this.status != null ? this.status.toLocaleString().toLowerCase() : '';
	}
}
